/* eslint-disable */
import {
	CheckCircle,
	ModeEdit,
	HighlightOff,
	Check,
	ArrowDownward,
	AddCircle,
} from '@mui/icons-material';
import { IconButton, ToggleButton, ToggleButtonGroup } from '@mui/material';
import moment from 'moment';
import { useEffect, useMemo, useState, useRef } from 'react';
import { useAuth } from '@/Components/Auth/Login/auth';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { analyticsAction, modalActions } from '../../../Actions';
import {
	classes,
	convertToLowerUnit,
	getHigherUnitAndQuantity,
	handleExcelDownload,
	multiplePoCustomers,
	useProductData,
} from '@/Helpers';
import { notificationServices } from '../../../Services';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import processFlowServices from '../../../Services/Analytics Services/process-flow.services';
// eslint-disable-next-line import/no-cycle
import { BaseModal } from '../BaseModal';
import styles from './ProductionPlanModal.module.scss';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { ListTable } from '@/Components/ListTable';
import { DatePicker, SelectPicker, Toggle } from 'rsuite';
import productionPlanServices from '../../../Services/Analytics Services/production-plan.services';
import weight from '@/Images/Weigh.svg';
import noWeight from '@/Images/noweigh.svg';
import { AlertModal } from '../AlertModal';
import useFeatureFlags from '@/Helpers/useFeatureFlags';
import { urls } from '@/Constants';
// import { ListTable } from '@/Components/ListTable';

const ProductionPlanModal = (props) => {
	const history = useHistory();
	const { show, toggleProductionPlanModal, data, stores } = props;

	const [planDescription, setPlanDescription] = useState('');
	const [loading, setLoading] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [isEdit, setIsEdit] = useState({});
	const [isEditFinalProduction, setIsEditFinalProduction] = useState({});
	const [skipMeasurementToggles, setSkipMeasurementToggles] = useState({});
	const [listData, setListData] = useState({
		INGREDIENT: [],
		INTERMEDIATE: [],
		PRODUCT: [],
		PACKAGING: [],
		leftOverCheckPlannedAhead: false,
		stockCheckedAt: new Date(),
		storeInfo: {},
	});

	const isLeftOverCheck = !!listData?.leftOverCheckPlannedAhead;
	const [prevListData, setPrevListData] = useState({});
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
	const dispatch = useDispatch();
	const { appConfig = {} } = useAuth();
	const [shiftId, setShiftId] = useState(null);
	const [selectedDate, setSelectedDate] = useState(new Date());
	const [processList, setProcessList] = useState([]);
	const [reasonList, setReasonList] = useState([]);
	const shiftList = useSelector((state) => state?.analytics?.SHIFT_LIST);
	// Filter shiftList based on storeId from data
	const filteredShiftList = useMemo(() => {
		if (!shiftList || !data?.storeId) return [];
		return shiftList.filter((shift) => shift?.storeId === data?.storeId);
	}, [shiftList, data?.storeId]);
	const isA2bCustomer = !multiplePoCustomers.includes(appConfig?.customerId);

	const { CAN_ORDER_IN_PACKS } = useFeatureFlags();

	const skuTypes = [
		{
			value: 'PRODUCT',
			color: '#FFD1DA',
		},
		{
			value: 'INTERMEDIATE',
			color: '#FBF1D3',
		},
		{
			value: 'INGREDIENT',
			color: '#D3FAC7',
		},
		{
			value: 'PACKAGING',
			color: '#D3E4FA',
		},
	].filter((item) => (item.value !== 'PACKAGING' || CAN_ORDER_IN_PACKS) && (item.value !== 'PACKAGING' || !data?.lppId));

	useEffect(() => {
		useProductData(dispatch);
	}, []);


	useEffect(() => {
		const fetchProcesses = async () => {
			if (data?.storeId) {
				try {
					const response = await processFlowServices.fetchNodes({
						params: { storeId: data.storeId },
					});
					if (response?.statusCode === 200) {
						setProcessList(response?.data?.nodes ?? []);
					}
				} catch (error) {
					console.error('Error fetching processes:', error);
				}
			}
		};
		fetchProcesses();
	}, [data?.storeId]);

	useEffect(() => {
		const fetchReasons = async () => {
			try {
				const response = await inventoryAnalyticsServices.fetchCategoryList({
					req: {
						data: { type: 'PRODUCTION_PLAN_REASON' },
					}
				});
				if (response?.statusCode === 200) {
					setReasonList(response?.data?.categories ?? []);
				}
			} catch (error) {
				console.error('Error fetching reasons:', error);
			}
		};
		fetchReasons();
	}, []);
	// eslint-disable-next-line no-unused-vars
	const [selectedType, setSelectedType] = useState({
		value: 'PRODUCT',
		color: '#FFD1DA',
	});

	// --- DRAFT HANDLING ---
	const draftExists = data?.draftExists;
	const isDraftEdit = !!data?.draftKey;
	const draftKey = data?.draftKey;
	const onDraftSaved = data?.onDraftSaved;
	// --- END DRAFT HANDLING ---

	const stockCheckedAt = moment(data?.listData?.stockCheckedAt)?.format(
		'DD-MMM HH:mm'
	);
	const stockCheckAtDate = moment(data?.listData?.stockCheckedAt)?.format(
		'DD-MMM'
	);
	const checkedAtDate = new Date(data?.listData?.stockCheckedAt);
	checkedAtDate.setDate(checkedAtDate.getDate() + 1);
	const nextStockCheckAtDate = moment(checkedAtDate)?.format('DD-MMM');
	const scheduledFor = moment(selectedDate)?.format('DD-MMM');
	const plannedDate = moment(new Date()).format('DD-MM-YYYY');

	const COLMAP = {
		'Product Name': 'id',
		Reason: 'id',
		Unit: 'unit',
		Category: 'category',
		'Sub Category': 'subCategory',
		'UY Id': 'id',
		'SKU Code': 'clientVariantId',
		'Measure Quantity': 'id',
		'From Process': 'From Process',
		'To Process': 'To Process',
		'Select Yield Process': 'id',
		[`Stock At ${stockCheckedAt}`]: 'stock',
		[`Plan ${stockCheckAtDate} Produced till ${stockCheckedAt}`]:
			'currentDayStockIn',
		[`Plan ${stockCheckAtDate} Planned Production`]: 'currentDayCount',
		[`Projected Stock at ${nextStockCheckAtDate} 7:59 AM`]: 'prePlanStock',
		[`Minimum Stock at ${nextStockCheckAtDate} 7:59 AM`]: 'threshold',
		[`Order Quantity PO Delivery Date ${scheduledFor}`]: 'orderedQty',
		'Forecast for Next 7 Days': 'forecasted',
		Scheduled: 'scheduledAtDelta',
		'Production Factor (+/- Manual Calibration)': 'updatedQty',
		'Pre Batch Production Quantity': 'calculatedQty',
		'Batch Size': 'batchSize',
		'Final Production': 'finalProduction',
		'Final Indent': 'finalProduction',
		'Recipe Exists': 'skipped',
		'Possible Production Qty': 'suggestedQty',
		[`Planned For Consumption ${plannedDate}`]: 'plannedForConsumption',
		[`Planned To be Received on ${plannedDate}`]: 'plannedToBeReceived',
		'No of batches': 'batchCount',
		'Shift ID': 'shiftId',
		'Shift Name': 'shiftName',
		'Parent Product': 'parentProduct',
		'Kit Batch Size': 'kitBatchSize',
		'Kit Count': 'kitCount',
		'Labelling Date': 'labellingDate',
		'Scheduled Date': 'scheduledDate',
	};

	const SPECIAL_COLUMNS = [
		{
			title: 'Product Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Unit',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Category',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Sub Category',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'SKU Code',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Measure Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'From Process',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'To Process',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Select Yield Process',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Scheduled',
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Planned For Consumption ${plannedDate}`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Planned To be Received on ${plannedDate}`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Stock At ${stockCheckedAt}`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Left Over (Input)',
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Plan ${stockCheckAtDate} Planned Extra Production`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Plan ${stockCheckAtDate} Produced till ${stockCheckedAt}`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Plan ${stockCheckAtDate} Planned Production`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Projected Stock at ${nextStockCheckAtDate} 7:59 AM`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Minimum Stock at ${nextStockCheckAtDate} 7:59 AM`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: `Order Quantity PO Delivery Date ${scheduledFor}`,
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Forecast for Next 7 Days',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Production Factor (+/- Manual Calibration)',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Reason',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Expected Left Over',
			config: {
				type: 'DATA',
			},
		},
		// {
		// 	title: 'Stock Info',
		// 	config: {
		// 		type: 'DATA',
		// 	},
		// },
		{
			title: 'Required Stock',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Current Stock',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Status',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Pre Batch Without Left Over',
			config: {
				type: 'DATA',
			},
		},

		{
			title: 'Left Over (Used/Input)',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Left Over (Already Planned)',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Left Over (From Executed plans)',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Pre Batch Production Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Possible Production Qty',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Wastage %',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Batch Size',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Final Production',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Final Indent',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Recipe Exists',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'No of batches',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Shift ID',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Shift Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Parent Product',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Kit Batch Size',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Kit Count',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Labelling Date',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Scheduled Date',
			config: {
				type: 'DATA',
			},
		},
	];

	// Packaging-specific columns
	const PACKAGING_COLUMNS = [
		{
			title: 'Item Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Item Code',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Pack Size',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Production Factor (+/- Manual Calibration)',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Packs Ordered',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Available Packs in Stock',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Packs to be packed',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Qty of SKU required',
			config: {
				type: 'DATA',
			},
		},
	];

	const mergeDelta = (saved, fresh) => {
		const merged = { ...fresh };

		Object.keys(fresh).forEach((key) => {
			if (Array.isArray(fresh[key])) {
				merged[key] = fresh[key].map((item) => {
					const id = getElementId(item);
					const matchingSaved = saved[key]?.find(
						(savedItem) => getElementId(savedItem) === id
					);
					return {
						...item,
						delta: matchingSaved?.delta ?? item.delta,
						updatedPacksToBePacked:
							matchingSaved?.updatedPacksToBePacked ??
							item.updatedPacksToBePacked,
					};
				});
			}
		});

		return merged;
	};


	const initializeLocalFields = (dataObj) => {
		const result = { ...dataObj };
		['PRODUCT', 'INTERMEDIATE', 'UNPACKED_PRODUCT', 'PACKAGING', 'INGREDIENT'].forEach((key) => {
			if (Array.isArray(result[key])) {
				result[key] = result[key].map((item) => ({
					...item,
					initialProductionQty: item.finalProduction,
					tempProductionValue: getHigherUnitAndQuantity(item?.unit, item?.finalProduction)[0],
					prevTempProductionValue: getHigherUnitAndQuantity(item?.unit, item?.finalProduction)[0],
				}));
			}
		});
		return result;
	};

	useEffect(() => {
		const saved = localStorage.getItem('unsavedListData');

		if (saved && data?.listData) {
			try {
				const savedData = JSON.parse(saved);
				const merged = mergeDelta(savedData, data.listData);
				setListData(initializeLocalFields(merged));
			} catch (e) {
				console.error('Invalid saved listData:', e);
				setListData(initializeLocalFields(data.listData));
			}
		} else if (data?.listData) {
			setListData(initializeLocalFields(data.listData));
		}

		// Initialize skipMeasurementToggles from data
		if (
			data?.listData?.skipMeasurementProducts &&
			Array.isArray(data.listData.skipMeasurementProducts)
		) {
			const initialToggles = {};
			data.listData.skipMeasurementProducts.forEach((productId) => {
				initialToggles[productId] = true;
			});
			setSkipMeasurementToggles(initialToggles);
		}
	}, [data?.listData]);

	useEffect(() => {
		setSelectedDate(new Date(data?.date));
		// Set shiftId from data, or default to first shift from filtered list
		if (data?.shiftId) {
			setShiftId(data?.shiftId);
		} else if (filteredShiftList?.length > 0) {
			setShiftId(filteredShiftList[0]?.id);
		}
	}, [data, filteredShiftList])

	useEffect(() => {
		if (shiftList?.length === 0) {
			dispatch(analyticsAction?.getShifts());
		}
	}, []);

	// Store idsList and planDescription in localStorage draft
	const autoSaveKey =
		draftKey ||
		(data?.idsList ? `unsavedListData_${data?.idsList.join('_')}` : null);
	const prevListDataRef = useRef();
	useEffect(() => {
		try {
			if (autoSaveKey && listData && listData !== prevListDataRef.current) {
				const draftObj = {
					...listData,
					idsList: data?.idsList ?? [],
					planDescription,
					skipMeasurementToggles,
				};
				localStorage.setItem(autoSaveKey, JSON.stringify(draftObj));
				prevListDataRef.current = listData;
			}
		} catch (e) {
			console.error('Error saving draft:', e);
		}
	}, [
		listData,
		autoSaveKey,
		data?.idsList,
		planDescription,
		skipMeasurementToggles,
	]);

	// On modal open, if draft exists, set planDescription and idsList from draft
	useEffect(() => {
		if (show && draftKey && localStorage.getItem(draftKey)) {
			try {
				const draft = JSON.parse(localStorage.getItem(draftKey));
				if (draft.planDescription !== undefined)
					setPlanDescription(draft.planDescription);
				if (draft.skipMeasurementToggles !== undefined)
					setSkipMeasurementToggles(draft.skipMeasurementToggles);
				if (
					draft.idsList !== undefined &&
					Array.isArray(draft.idsList)
				) {
					// Optionally set idsList in parent if needed
				}
			} catch (e) { }
		} else if (show && data?.planDescription) {
			setPlanDescription(data.planDescription);
		}

		// Initialize skipMeasurementToggles from data if no draft exists
		if (
			show &&
			!draftKey &&
			data?.listData?.skipMeasurementProducts &&
			Array.isArray(data.listData.skipMeasurementProducts)
		) {
			const initialToggles = {};
			data.listData.skipMeasurementProducts.forEach((productId) => {
				initialToggles[productId] = true;
			});
			setSkipMeasurementToggles(initialToggles);
		}
	}, [show, draftKey, data?.planDescription, data?.listData?.skipMeasurementProducts]);



	const handleClose = (productionPlanId) => {
		setPlanDescription('');
		setPrevListData({});
		setIsEdit({});
		setSkipMeasurementToggles({});
		setIsEditFinalProduction({});
		toggleProductionPlanModal(false, {});
		const id = (typeof productionPlanId === 'string' || typeof productionPlanId === 'number') ? productionPlanId : undefined;
		if (props.onCloseModal) props.onCloseModal(id);
	};

	const getUpdatedQty = (delta, orderedQty, updatedQty) => {
		if (!delta) {
			return updatedQty;
		}
		return Number(delta) + (orderedQty ?? 0);
		// return updatedQty;
	};

	const getElementId = (ele) => {
		return (
			String(ele?.variantId ?? '') +
			'_' + String(ele?.fromProcessId ?? '') +
			'_' + String(ele?.scheduledAtDelta ?? '') +
			(ele?.packId ? '_pk' + ele.packId : '') +
			(ele?.shiftId != null ? '_s' + ele.shiftId : '') +
			(ele?.parentProduct ? '_p' + ele.parentProduct : '')
		);
	};

	const items = useMemo(() => {
		const flattenData = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
			...(listData?.UNPACKED_PRODUCT ?? []),
			...(listData?.PACKAGING ?? []),
		];
		if (show) {
			const temp = flattenData?.map((ele) => {
				const { delta, ...restEle } = ele ?? {};
				return {
					...restEle,
					updatedQty: getUpdatedQty(
						delta,
						ele?.orderedQty,
						ele?.updatedQty
					),
					updatedPacksToBePacked:
						ele?.updatedPacksToBePacked != null &&
							ele?.updatedPacksToBePacked !== '' &&
							!isNaN(parseFloat(ele?.updatedPacksToBePacked))
							? parseFloat(ele?.updatedPacksToBePacked)
							: null,
				};
			});
			return temp;
		}
		return [];
	}, [data?.listData, listData?.PRODUCT, listData?.INTERMEDIATE, listData?.UNPACKED_PRODUCT, listData?.PACKAGING]);

	const getUniqueSkipMeasurementIds = () => {
		try {
			if (!listData?.INGREDIENT || !Array.isArray(listData?.INGREDIENT)) {
				return [];
			}

			const allProductIds = [];


			Object.keys(skipMeasurementToggles).forEach(productId => {
				if (skipMeasurementToggles[productId]) {
					allProductIds.push(parseInt(productId));
				}
			});

			return [...new Set(allProductIds)];

		} catch (error) {
			console.error('Error processing skip measurement data:', error);
			return [];
		}
	};

	const handleConfirm = async () => {
		if (data?.editMode) {
			dispatch(modalActions?.toggleAlert(false));
		}
		let submitIdsList = data?.idsList ?? [];
		let submitPlanDescription = planDescription;
		if (draftKey && localStorage.getItem(draftKey)) {
			try {
				const draft = JSON.parse(localStorage.getItem(draftKey));
				if (draft.idsList !== undefined) submitIdsList = draft.idsList;
				// if (draft.planDescription !== undefined) submitPlanDescription = draft.planDescription;
			} catch (e) { }
		}
		if (
			submitIdsList &&
			submitIdsList.length === 0 &&
			!draftExists &&
			!data?.editMode &&
			!data?.lppId
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'No PO Selected',
			});
			return;
		}
		if (!draftExists && !data?.storeId) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'No Store selected',
			});
			return;
		}
		if (!submitPlanDescription) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please add Plan Description',
			});
			return;
		}
		// Validate reason selection for changed items
		const allChangedItems = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
		].filter((ele) => ele?.delta != null && ele?.delta !== 0);
		const missingReason = allChangedItems.some((ele) => {
			if (!ele?.reasonId) return true;
			const reason = reasonList.find((r) => String(r.id) === String(ele?.reasonId));
			if (reason?.value === 'Other' && !ele?.customReasonInput) return true;
			return false;
		});
		if (missingReason && Array.isArray(reasonList) && reasonList?.length > 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a reason for all items where Production Factor has been changed',
			});
			return;
		}
		const req = {
			data: {
				...(data?.productionPlanId
					? { cancelPPId: data?.productionPlanId }
					: {}),
				poIds: submitIdsList,
				description: submitPlanDescription,
				storeId: data?.storeId,
				items,
				stockCheckedAt: data?.listData?.stockCheckedAt,
				storeInfo: data?.listData?.storeInfo,
				skipMeasurementProducts: getUniqueSkipMeasurementIds(),
				...(data?.lppId ? { lppId: data?.lppId } : {}),
				...(data?.shiftDistribution ? { shiftDistribution: data?.shiftDistribution } : {}),
			},
		};
		if (selectedDate) {
			req.data.date = moment(selectedDate).format('YYYY-MM-DD');
		}
		try {
			setLoading(true);
			const response =
				await inventoryAnalyticsServices?.generateProductionPlan(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Generated Successfully',
				});
				handleClose(response?.data?.productionPlanId);
				localStorage.removeItem('unsavedListData');
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error Occurred',
			});
		} finally {
			setLoading(false);
		}
	};

	const handleRecalculate = async () => {
		const allChangedItems = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
		].filter((ele) => ele?.delta != null && ele?.delta !== 0);

		const missingReason = allChangedItems.some((ele) => {
			if (!ele?.reasonId) return true;
			const reason = reasonList.find((r) => String(r.id) === String(ele?.reasonId));
			if (reason?.value === 'Other' && !ele?.customReasonInput) return true;
			return false;
		});

		if (missingReason && Array.isArray(reasonList) && reasonList?.length > 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a reason for all items where Production Factor has been changed',
			});
			return;
		}

		let recalcIdsList = data?.idsList ?? [];
		let recalcPlanDescription = planDescription;
		if (draftKey && localStorage.getItem(draftKey)) {
			try {
				const draft = JSON.parse(localStorage.getItem(draftKey));
				if (draft.idsList !== undefined) recalcIdsList = draft.idsList;
				if (draft.planDescription !== undefined) recalcPlanDescription = draft.planDescription;
			} catch (e) { }
		}
		setLoading(true);
		try {
			setPrevListData(listData);
			const req = {
				data: {
					poIds: recalcIdsList,
					storeId: data?.storeId,
					date: moment(selectedDate).format('YYYY-MM-DD'),
					recalculate: true,
					stockCheckedAt: data?.listData?.stockCheckedAt,
					storeInfo: data?.listData?.storeInfo,
					items,
					description: recalcPlanDescription,
					...(data?.shiftDistribution ? { shiftDistribution: data?.shiftDistribution } : {}),
					...(data?.lppId ? { lppId: data?.lppId } : {}),
				},
			};
			const response =
				await inventoryAnalyticsServices?.fetchProductionPlan(req);
			if (response?.statusCode === 200) {
				setListData(initializeLocalFields(response?.data));
				setIsEdit({});
				setIsEditFinalProduction({});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Generated Successfully',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error Occurred',
			});
		} finally {
			setLoading(false);
		}
	};

	const checkLowStock = () => {
		const productLowStock = listData?.PRODUCT?.filter((ele) => {
			return ele?.lowStock;
		}).some((ele) => {
			return ele?.lowStock;
		});
		const intermediateLowStock = [...listData?.INTERMEDIATE, ...(listData?.UNPACKED_PRODUCT ?? [])]?.filter((ele) => {
			return ele?.lowStock;
		}).some((ele) => {
			return ele?.lowStock;
		});
		const ingredientLowStock = listData?.INGREDIENT?.filter((ele) => {
			return ele?.lowStock && ele?.threshold !== 0;
		}).some((ele) => {
			return ele?.lowStock;
		});
		if (productLowStock || intermediateLowStock || ingredientLowStock) {
			return true;
		}
		return false;
	};

	const handleConfirmation = () => {
		dispatch(modalActions?.toggleAlert(true, {
			title: 'Edit Production Plan',
			message: `Are you sure you want to edit this production plan?`,
			handleConfirm: handleConfirm
		}))
	}

	const renderBtns = () => {
		return (
			!data?.hideButtons && (
				<div className={styles.btns}>
					<Button
						className='flex-1'
						disabled={(Object.keys(isEdit)?.length === 0 && Object.keys(isEditFinalProduction)?.length === 0) || loading}
						onClick={handleRecalculate}
						variant='secondary'
					>
						Re-Calculate
					</Button>
					<Button
						className='flex-1 primary-btn'
						onClick={
							data?.editMode ? handleConfirmation : handleConfirm
						}
						disabled={checkLowStock() || loading || ((Object.keys(isEdit)?.length > 0 || Object.keys(isEditFinalProduction)?.length > 0))}
					>
						{loading ? 'Loading...' : 'Generate'}
					</Button>
				</div>
			)
		);
	};

	const handleChange = (e) => {
		setPlanDescription(e.target.value);
	};

	const handleEditClick = (varId) => {
		setIsEdit((prev) => {
			const temp = {
				...prev,
			};
			if (temp[varId]) {
				temp[varId] = false;
			} else {
				temp[varId] = true;
			}
			return temp;
		});
	};

	const handleFinalProductionEditClick = (varId) => {
		setIsEditFinalProduction((prev) => {
			const temp = {
				...prev,
			};
			if (temp[varId]) {
				temp[varId] = false;
			} else {
				temp[varId] = true;
			}
			return temp;
		});
	};

	const handleFinalProductionChange = (e, elementId) => {
		const inputValue = e?.target.value;
		// Prevent negative numbers
		if (inputValue !== '' && Number(inputValue) < 0) return;

		// Update the temporary value in list data
		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;

			temp[currentType] = temp[currentType]?.map((ele) => {
				if (elementId === getElementId(ele)) {
					return {
						...ele,
						tempProductionValue: inputValue,
					};
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const handleFinalProductionSave = (elementId) => {
		let validationFailed = false;

		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;

			temp[currentType] = temp[currentType]?.map((ele) => {
				if (elementId === getElementId(ele)) {
					const inputValue = ele.tempProductionValue;
					const lowerUnitValue = inputValue !== '' && inputValue !== null
						? convertToLowerUnit(ele?.unit, inputValue)
						: inputValue;
					const deltaValue = ele?.updatedQty === ele?.orderedQty
						? 0
						: ele?.updatedQty - ele?.orderedQty;
					const nonAdjustQty = ele?.calculatedQtyNonAdjusted < 0 ? Math.abs(parseFloat(ele?.calculatedQtyNonAdjusted)) : 0;
					const oldDeltaValue = ele?.delta ? ele?.delta : deltaValue
					const initialLowerQty = ele.prevTempProductionValue ? convertToLowerUnit(ele?.unit, ele.prevTempProductionValue) : 0;
					const newDelta = (oldDeltaValue + (lowerUnitValue - initialLowerQty)) + nonAdjustQty;
					const initialProductItem = prevListData?.[currentType]?.find((prod) => getElementId(prod) === elementId);
					let minPossibleVal;
					if (initialProductItem && initialProductItem?.delta) {
						minPossibleVal = Number(ele?.calculatedQty - Number(initialProductItem?.delta));
					} else {
						minPossibleVal = ele?.calculatedQty;
					}

					if (newDelta < -minPossibleVal) {
						validationFailed = true;

						const minAllowedLower = minPossibleVal;
						const [minAllowedHigher] = getHigherUnitAndQuantity(ele?.unit, minAllowedLower);

						notificationServices.generateNotification({
							type: 'warning',
							message: `Value too low. The minimum allowed production quantity is -${Number(minAllowedHigher).toFixed(2)}.`,
						});
						return ele;
					}
					return {
						...ele,
						finalProduction: lowerUnitValue,
						delta: newDelta,
						prevTempProductionValue: inputValue,
					};
				}
				return ele;
			});
			return { ...temp };
		});

		if (validationFailed) {
			return;
		}

		handleFinalProductionEditClick(elementId);
	};

	const handleQtyChange = (e, elementId) => {
		setListData((prev) => {
			const temp = {
				...prev,
			};
			temp[selectedType?.value] = temp[selectedType?.value]?.map(
				(ele) => {
					if (elementId === getElementId(ele)) {
						// User enters in higher unit (kg/ltr), convert to lower unit (gm/ml) for storage
						const inputValue = e?.target.value;
						const lowerUnitValue = inputValue !== '' && inputValue !== null
							? convertToLowerUnit(ele?.unit, inputValue)
							: inputValue;
						return {
							...ele,
							delta: lowerUnitValue,
							deltaHigherUnit: inputValue, // Store higher unit value for display
						};
					}
					return ele;
				}
			);
			return {
				...temp,
			};
		});
	};

	const handlePacksOrderedChange = (e, elementId) => {
		const value = e?.target.value;
		setListData((prev) => {
			const temp = {
				...prev,
			};
			temp.PACKAGING = temp.PACKAGING?.map((ele) => {
				if (elementId === getElementId(ele)) {
					return {
						...ele,
						updatedPacksToBePacked: value,
					};
				}
				return ele;
			});
			return {
				...temp,
			};
		});
	};

	const handleProcessChange = (value, id) => {
		setListData((prev) => {
			const temp = { ...prev };
			temp[selectedType?.value] = temp[selectedType?.value]?.map((ele) => {
				if (id === getElementId(ele)) {
					return { ...ele, toProcessId: value };
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const handleReasonChange = (value, id) => {
		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;
			temp[currentType] = temp[currentType]?.map((ele) => {
				if (id === getElementId(ele)) {
					const selectedReason = reasonList.find((r) => String(r.id) === String(value));
					return {
						...ele,
						reasonId: value,
						...(selectedReason?.value !== 'Other' ? { customReasonInput: '' } : {}),
					};
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const handleCustomReasonInputChange = (value, id) => {
		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;
			temp[currentType] = temp[currentType]?.map((ele) => {
				if (id === getElementId(ele)) {
					return { ...ele, customReasonInput: value };
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const handleAddRecipe = (id) => {
		history.push(`/console2/kitchen/cooking/recipe/view/${id}`);
	};

	const getStatus = (type, lowStock, threshold) => {
		if (type === 'Ingredient') {
			if (lowStock && threshold === 0) {
				return (
					<p className='text-xs font-medium bg-blue-200 rounded-md p-1 flex items-center gap-1'>
						Freshly Procure
					</p>
				);
			}
			if (lowStock && threshold !== 0) {
				return (
					<p className='text-xs font-medium bg-red-200 rounded-md p-1 flex items-center gap-1'>
						<ArrowDownward
							style={{
								color: '#EF4444',
								width: '16px',
								height: '16px',
							}}
						/>
						Low Stock
					</p>
				);
			}
			if (!lowStock) {
				return (
					<p className='text-xs font-medium bg-green-200 rounded-md p-1 flex items-center gap-1'>
						In Stock
					</p>
				);
			}
		}
		if (type === 'Product') {
			if (lowStock) {
				return (
					<p className='text-xs font-medium bg-red-200 rounded-md p-1 flex items-center gap-1'>
						<ArrowDownward
							style={{
								color: '#EF4444',
								width: '16px',
								height: '16px',
							}}
						/>
						Low Stock
					</p>
				);
			}
			if (!lowStock) {
				return (
					<p className='text-xs font-medium bg-green-200 rounded-md p-1 flex items-center gap-1'>
						In Stock
					</p>
				);
			}
		}
		if (type === 'Intermediate') {
			if (lowStock) {
				return (
					<p className='text-xs font-medium bg-red-200 rounded-md p-1 flex items-center gap-1'>
						<ArrowDownward
							style={{
								color: '#EF4444',
								width: '16px',
								height: '16px',
							}}
						/>
						Low Stock
					</p>
				);
			}
			if (!lowStock) {
				return (
					<p className='text-xs font-medium bg-green-200 rounded-md p-1 flex items-center gap-1'>
						In Stock
					</p>
				);
			}
		}
		return '-';
	};

	const handleToggleSkipMeasurement = (value, id) => {
		const product = listData?.[selectedType?.value]?.find((prod) => {
			return getElementId(prod) === id;
		});

		if (product?.productId) {
			setSkipMeasurementToggles((prev) => ({
				...prev,
				[product.productId]: value,
			}));
		}
	};

	const SPECIAL_ITEMS = {
		[`Planned For Consumption ${plannedDate}`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return parseFloat(product?.plannedForConsumption).toFixed(2) ?? '-';
		},
		[`Planned To be Received on ${plannedDate}`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return parseFloat(product?.plannedToBeReceived).toFixed(2) ?? '-';
		},
		'Product Name': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return (
				<div className='flex items-start gap-1 flex-col'>
					<span>
						{product?.productName}
						{product?.variantName && (
							<span className='text-xs font-medium rounded-md p-1 ml-1 bg-blue-200'>
								{product?.variantName}
							</span>
						)}
					</span>
				</div>
			);
		},
		Reason: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if ((Array.isArray(reasonList) && reasonList?.length === 0) || !reasonList) return '-';
			const isProductOrIntermediate =
				selectedType?.value === 'PRODUCT' ||
				selectedType?.value === 'INTERMEDIATE';
			const hasChangedDelta = (product?.delta != null && product?.delta !== 0) || product?.reasonId;

			if (!isProductOrIntermediate || !hasChangedDelta) {
				return <span className='text-gray-400'>-</span>;
			}

			const needsReason = !product?.reasonId;
			const selectedReason = reasonList.find((r) => String(r.id) === String(product?.reasonId));
			const isOther = selectedReason?.value === 'Other';

			if (data?.nonEditable) {
				return (
					<div className='text-xs'>
						{selectedReason?.value ?? '-'}
						{isOther && product?.customReasonInput && ` (${product.customReasonInput})`}
					</div>
				);
			}

			return (
				<div className={`w-full min-w-[150px] ${needsReason ? 'rounded-md p-1 bg-red-50 border border-red-300 animate-pulse' : ''}`}>
					<SelectPicker
						data={reasonList.map((reason) => ({
							label: reason.value,
							value: String(reason.id),
						}))}
						placeholder='Select Reason'
						className={`w-full ${needsReason ? 'border-red-400 ring-1 ring-red-300' : ''}`}
						value={String(product?.reasonId || '')}
						onChange={(value) => handleReasonChange(value, id)}
						cleanable={false}
						searchable={true}
						menuClassName='z-[99999]'
					/>
					{isOther && (
						<Input
							className='mt-1 h-8 text-xs'
							placeholder='Enter reason'
							value={product?.customReasonInput || ''}
							onChange={(e) =>
								handleCustomReasonInputChange(e.target.value, id)
							}
							disabled={data?.nonEditable}
						/>
					)}
				</div>
			);
		},
		'Kit Batch Size': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.kitBatchSize == null) return '-';
			const [kitBatchSize, _] = getHigherUnitAndQuantity(product?.unit, product?.kitBatchSize);
			return kitBatchSize;
		},
		'Kit Count': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.kitCount ?? '-';
		},
		'Labelling Date': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.labellingDate ?? '-';
		},
		'Scheduled Date': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.scheduledDate ?? '-';
		},
		'Measure Quantity': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const skipMeasurement = skipMeasurementToggles[product?.productId] || false;
			return (
				<div className='flex flex-1 items-center gap-1 justify-center'>
					<div className='relative'>
						{/* Toggle Container */}
						<div className='flex items-center border border-gray-300 rounded-lg p-1 bg-white relative'>
							{/* Sliding Background */}
							<div
								className={`absolute top-1 bottom-1 w-8 h-6 rounded-md transition-all duration-300 ease-in-out ${!skipMeasurement
									? 'bg-green-500 left-1'
									: 'bg-red-200 left-9'
									}`}
							/>

							{/* Weight Button */}
							<button
								onClick={() =>
									handleToggleSkipMeasurement(false, id)
								}
								disabled={data?.nonEditable}
								className={`relative flex items-center justify-center w-8 h-6 rounded-md transition-all duration-200 ${data?.Editable ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'
									}`}
								title="Weight"
							>
								<img
									src={weight}
									alt='weight'
									className={`w-4 h-4 transition-all duration-200 ${!skipMeasurement ? 'filter brightness-0' : 'filter brightness-75'
										}`}
								/>
							</button>

							{/* No Weight Button */}
							<button
								onClick={() =>
									handleToggleSkipMeasurement(true, id)
								}
								disabled={data?.nonEditable}
								className={`relative flex items-center justify-center w-8 h-6 rounded-md transition-all duration-200 ${data?.nonEditable ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'
									}`}
								title="No Weight"
							>
								<img
									src={noWeight}
									alt='no weight'
									className={`w-4 h-4 transition-all duration-200 ${skipMeasurement ? 'filter brightness-0' : 'filter brightness-75'
										}`}
								/>
							</button>
						</div>
					</div>
				</div>
			);
		},
		Unit: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [_, unit] = getHigherUnitAndQuantity(product?.unit, 0);
			return unit;
		},
		Category: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.categoryName ?? '-';
		},
		'Sub Category': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return (
				products?.find((val) => val?.id === product?.productId)
					?.subCategoryName ?? '-'
			);
		},
		'SKU Code': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return (
				products
					?.find((val) => val?.id === product?.productId)
					?.variants?.find(
						(variant) => variant?.id === product?.variantId
					)?.clientVariantId ?? '-'
			);
		},
		'From Process': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.fromProcess;
		},
		'To Process': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.toProcess;
		},
		'Select Yield Process': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (data?.nonEditable) {
				const process = processList?.find((ele) => {
					return Number(ele?.id) === Number(product?.toProcessId);
				});
				return <div className='flex items-center gap-1'>{process?.data?.heading ?? ''}({process?.data?.sectionName ?? ''})</div>
			}
			return (
				<SelectPicker
					data={processList?.map((ele) => ({
						label: `${ele?.data?.heading ?? ''}(${ele?.data?.sectionName ?? ''})`,
						value: ele?.id,
					}))}
					placeholder='Select Yield Process'
					className='w-[180px]'
					value={product?.toProcessId != null ? Number(product?.toProcessId) : null}
					onChange={(value) => handleProcessChange(value, id)}
					cleanable={true}
					searchable={true}
					menuClassName='z-[99999]'
				/>
			);
		},
		Scheduled: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			let str = '';
			if (product?.scheduledAtDelta) {
				if (product?.scheduledAtDelta < 0) {
					str = 'T' + product?.scheduledAtDelta;
				} else if (product?.scheduledAtDelta === 0) {
					str = 'T';
				} else {
					str = 'T+' + product?.scheduledAtDelta;
				}
			}
			return str;
		},
		[`Stock At ${stockCheckedAt}`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [stock, _] = getHigherUnitAndQuantity(product?.unit, product?.stock);
			return stock;
		},
		[`Projected Stock at ${nextStockCheckAtDate} 7:59 AM`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.prePlanStock == null) return '-';
			const [prePlanStock, _] = getHigherUnitAndQuantity(product?.unit, product?.prePlanStock);
			return prePlanStock;
		},
		[`Minimum Stock at ${nextStockCheckAtDate} 7:59 AM`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [threshold, _] = getHigherUnitAndQuantity(product?.unit, product?.threshold);
			return threshold;
		},
		[`Order Quantity PO Delivery Date ${scheduledFor}`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [value, unit] = getHigherUnitAndQuantity(product?.unit, product?.orderedQty);
			return value;
		},
		'Pre Batch Production Quantity': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [calculatedQty, calculatedQtyUnit] = getHigherUnitAndQuantity(product?.unit, product?.calculatedQty);
			const [calculatedQtyNonAdjusted, calculatedQtyNonAdjustedUnit] = getHigherUnitAndQuantity(product?.unit, product?.calculatedQtyNonAdjusted);
			return (
				calculatedQty +
				(calculatedQtyNonAdjusted < 0
					? // eslint-disable-next-line prefer-template
					'(' + calculatedQtyNonAdjusted + ')'
					: '')
			);
		},
		// 'Stock Info': (id) => {
		// 	const product = listData?.[selectedType?.value]?.find((prod) => {
		// 		return getElementId(prod) === id;
		// 	});
		// 	return (
		// 		<div className='flex items-center justify-center flex-row gap-1'>
		// 			<div className='flex flex-col items-center gap-2'>
		// 				{
		// 					![undefined, null].includes(product?.stock) && (
		// 						<span className='text-xs font-medium bg-gray-200 p-1 rounded-md'>{product?.stock}</span>
		// 					)
		// 				}
		// 				{
		// 					![undefined, null].includes(product?.totalRequiredQty) && (
		// 						<span className='text-xs font-medium bg-blue-200 p-1 rounded-md'>{Number(product?.totalRequiredQty ?? 0).toFixed(0)}</span>
		// 					)
		// 				}
		// 			</div>
		// 			{product?.lowStock && (
		// 			<div className='flex items-center gap-2'>
		// 				<ArrowDownward style={{ color: '#EF4444', width: '16px', height: '16px' }} />
		// 			</div>
		// 				)}
		// 		</div>
		// );
		// },
		'Required Stock': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [totalRequiredQty, _] = getHigherUnitAndQuantity(product?.unit, product?.totalRequiredQty);
			return Number(totalRequiredQty ?? 0).toFixed(2);
		},
		'Current Stock': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [stock, _] = getHigherUnitAndQuantity(product?.unit, product?.stock);
			return Number(stock ?? 0).toFixed(2);
		},
		Status: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (selectedType?.value === 'INGREDIENT') {
				return getStatus(
					'Ingredient',
					product?.lowStock,
					product?.threshold
				);
			}
			if (selectedType?.value === 'PRODUCT') {
				return getStatus(
					'Product',
					product?.lowStock,
					product?.threshold
				);
			}
			if (selectedType?.value === 'INTERMEDIATE') {
				return getStatus(
					'Intermediate',
					product?.lowStock,
					product?.threshold
				);
			}
			return '-';
		},
		'Wastage %': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.wastage ?? '-';
		},
		'Possible Production Qty': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [suggestedQty, _] = getHigherUnitAndQuantity(product?.unit, product?.suggestedQty);
			if (selectedType?.value === 'PRODUCT') {
				if (product?.orderedQty > product?.suggestedQty) {
					return (
						<span className='font-medium text-red-600'>
							{Number(suggestedQty).toFixed(2)}
						</span>
					);
				}
				return (
					<span className='font-medium'>
						{Number(suggestedQty).toFixed(2)}
					</span>
				);
			}
			return Number(suggestedQty).toFixed(2) ?? '-';
		},
		'Batch Size': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [batchSize, _] = getHigherUnitAndQuantity(product?.unit, product?.batchSize);
			if (batchSize) {
				return batchSize;
			}
			return !data?.hideButtons && <Button onClick={() => window.open(`${urls.EXTENSION}${urls.VARIANT_BATCH_SIZE}?productId=${product?.productId}&variantId=${product?.variantId}&storeId=${data?.storeId}&productName=${product?.productName + (product?.variantName ? ` (${product?.variantName})` : '')}`)} className='px-2 h-6 text-[11px] bg-blue-400 hover:bg-blue-500 text-white' > Add Batch Size</Button>;
		},
		'Final Production': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [finalProduction, _] = getHigherUnitAndQuantity(product?.unit, product?.finalProduction);
			const initialHigher = product?.initialProductionQty ? getHigherUnitAndQuantity(product?.unit, product?.initialProductionQty)[0] : '';
			if (isEditFinalProduction[id]) {
				const tempFinalProductionHigher = product?.tempProductionValue ? product?.tempProductionValue : '';
				return (
					<div>
						<p className='text-xs text-gray-600 mb-1'>Initial: {initialHigher}</p>
						<Input
							type='number'
							min='0'
							value={tempFinalProductionHigher}
							onChange={(e) => handleFinalProductionChange(e, id)}
						/>
						<IconButton
							onClick={() => {
								handleFinalProductionSave(id);
							}}
						>
							<CheckCircle />
						</IconButton>
					</div>
				);
			}
			return (
				<div>
					{Number(finalProduction).toFixed(2)}
					{(!data?.nonEditable && !product?.notScheduled && String(appConfig?.customerId) === '70' && selectedType?.value === 'PRODUCT') && (
						<IconButton
							onClick={() => {
								handleFinalProductionEditClick(getElementId(product));
							}}
							className={styles['edit-btn']}
						>
							<ModeEdit />
						</IconButton>
					)}
				</div>
			);
		},
		'Final Indent': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [finalProduction, _] = getHigherUnitAndQuantity(product?.unit, product?.finalProduction);
			return Number(finalProduction).toFixed(2);
		},
		[`Plan ${stockCheckAtDate} Planned Production`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [currentDayCount, _] = getHigherUnitAndQuantity(product?.unit, product?.currentDayCount);
			return currentDayCount;
		},
		[`Plan ${stockCheckAtDate} Produced till ${stockCheckedAt}`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const [currentDayStockIn, _] = getHigherUnitAndQuantity(product?.unit, product?.currentDayStockIn);
			return currentDayStockIn;
		},
		'Forecast for Next 7 Days': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.forecasted == null) return '-';
			const [forecasted, _] = getHigherUnitAndQuantity(product?.unit, product?.forecasted);
			return forecasted;
		},
		'Left Over (From Executed plans)': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.leftOver == null) return '-';
			const [leftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.leftOver);
			return leftOver;
		},
		'Left Over (Already Planned)': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.plannedLeftOver == null) return '-';
			const [plannedLeftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.plannedLeftOver);
			return plannedLeftOver;
		},
		'Pre Batch Without Left Over': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.calculatedQtyNonAdjusted == null) return '-';
			const [calculatedQtyNonAdjusted, _] = getHigherUnitAndQuantity(product?.unit, product?.calculatedQtyNonAdjusted);
			return calculatedQtyNonAdjusted;
		},
		'Left Over (Used/Input)': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (!product?.leftOver || !product?.inputLeftOver) return '-';
			const [leftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.leftOver);
			const [inputLeftOver, __] = getHigherUnitAndQuantity(product?.unit, product?.inputLeftOver);
			return leftOver + '/' + inputLeftOver;
		},
		'Left Over (Input)': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.stock == null) return '-';
			const [stock, _] = getHigherUnitAndQuantity(product?.unit, product?.stock);
			return stock;
		},
		[`Plan ${stockCheckAtDate} Planned Extra Production`]: (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.extraScheduled == null) return '-';
			const [extraScheduled, _] = getHigherUnitAndQuantity(product?.unit, product?.extraScheduled);
			return extraScheduled;
		},
		'Expected Left Over': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			if (product?.expectedLeftOver == null) return '-';
			const [expectedLeftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.expectedLeftOver);
			return expectedLeftOver;
		},
		'Production Factor (+/- Manual Calibration)': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			const initialProductData = prevListData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});

			// Convert to higher unit for display
			const [initialValueHigher, _] = getHigherUnitAndQuantity(
				product?.unit,
				product?.updatedQty === product?.orderedQty
					? 0
					: product?.updatedQty - product?.orderedQty
			);

			const hasError = Number(product?.delta) < -initialProductData?.calculatedQty;

			let minPossible;
			if (initialProductData && initialProductData?.delta) {
				minPossible = Number(product?.calculatedQty - Number(initialProductData?.delta));
			} else {
				minPossible = product?.calculatedQty;
			}

			// Convert minPossible to higher unit for display
			const [minPossibleHigher, __] = getHigherUnitAndQuantity(product?.unit, minPossible);

			// Get the display value for delta in higher unit
			const [deltaHigher, ___] = getHigherUnitAndQuantity(product?.unit, product?.delta);
			const [updatedQtyDiffHigher, ____] = getHigherUnitAndQuantity(
				product?.unit,
				product?.updatedQty - product?.orderedQty
			);
			const displayValue = product?.delta ? deltaHigher : (product?.updatedQty !== product?.orderedQty ? updatedQtyDiffHigher : 0);
			if (String(appConfig?.customerId) === '70' && selectedType?.value === 'PRODUCT') {
				return (
					<div className='flex flex-col items-center justify-center text-center py-1'>
						<p className='text-[11px] text-gray-500 text-nowrap'>Min possible = -{minPossibleHigher}</p>
						<p className='text-sm font-semibold mt-1.5 text-gray-800'>{displayValue}</p>
					</div>
				);
			}

			if (isEdit[getElementId(product)]) {
				const inputDisplayValue = product?.deltaHigherUnit ?? (product?.delta != null ? deltaHigher : initialValueHigher);
				return (
					<div>
						<p className='text-xs text-gray-600 mb-1'>Min possible = -{minPossibleHigher}</p>
						<Input
							style={{
								outline: hasError ? 'none' : '',
								border: hasError ? '2px solid red' : '',
								color: hasError ? 'red' : '',
							}}
							type='number'
							placeholder='Change Order QTY'
							value={inputDisplayValue}
							onChange={(e) => {
								handleQtyChange(e, id);
							}}
						/>
						<IconButton
							onClick={() => {
								if (hasError) {
									notificationServices.generateNotification({
										type: 'warning',
										message: 'Please check value',
									});
									return;
								}
								handleEditClick(getElementId(product));
							}}
						>
							<CheckCircle />
						</IconButton>
					</div>
				);
			}
			return (
				<span className={styles['order-qty']}>
					{/* <s className={styles.actual}>{product?.orderedQty}</s> */}
					<p>{displayValue}</p>
					{(!data?.nonEditable && !product?.notScheduled) && (
						<IconButton
							onClick={() => {
								handleEditClick(getElementId(product));
							}}
							className={styles['edit-btn']}
						>
							<ModeEdit />
						</IconButton>
					)}
				</span>
			);
		},
		'Recipe Exists': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});

			return !product?.skipped ? (
				<Check />
			) : (
				<div className={styles['no-recipe']}>
					<HighlightOff />
					<IconButton
						onClick={() => {
							handleAddRecipe(product?.productId);
						}}
						className={styles['add-recipe']}
						disabled={product?.notScheduled === true}
					>
						<AddCircle className={styles.icon} />
						<p>Add Recipe</p>
					</IconButton>
				</div>
			);
		},
		'No of batches': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.batchCount ?? '-';
		},
		'Shift ID': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.shiftId ?? '-';
		},
		'Shift Name': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.shiftName ?? '-';
		},
		'Parent Product': (id) => {
			const product = listData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.parentProduct ?? '-';
		},
	};

	// Packaging-specific special items
	const PACKAGING_SPECIAL_ITEMS = {
		'Item Name': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			return (
				<div className='flex items-start gap-1 flex-col'>
					<span>
						{product?.productName}
						{product?.variantName && (
							<span className='text-xs font-medium bg-blue-200 rounded-md p-1 ml-1'>
								{product?.variantName}
							</span>
						)}
					</span>
				</div>
			);
		},
		'Item Code': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.itemCode ?? product?.variantId ?? '-';
		},
		'Pack Size': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			return (
				<div className='flex items-center gap-1'>
					<span className='text-xs font-medium bg-yellow-100 text-yellow-700 rounded-md px-2 py-1'>
						{product?.packName ||
							`Pack of ${product?.packSize || product?.batchSize || '-'
							}`}
					</span>
				</div>
			);
		},
		'Production Factor (+/- Manual Calibration)': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.productionFactor ?? 1;
		},
		'Packs Ordered': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			const originalPacksOrdered =
				product?.packsOrdered ?? product?.orderedQty ?? 0;
			const displayValue =
				product?.updatedPacksToBePacked !== undefined
					? product?.updatedPacksToBePacked
					: originalPacksOrdered;

			const hasError = Number(displayValue) < 0;

			if (isEdit[getElementId(product)]) {
				return (
					<div>
						<Input
							style={{
								outline: hasError ? 'none' : '',
								border: hasError ? '2px solid red' : '',
								color: hasError ? 'red' : '',
							}}
							type='number'
							min='0'
							placeholder='Enter Packs Ordered'
							value={displayValue}
							onChange={(e) => {
								handlePacksOrderedChange(
									e,
									getElementId(product)
								);
							}}
						/>
						<IconButton
							onClick={() => {
								if (hasError) {
									notificationServices.generateNotification({
										type: 'warning',
										message:
											'Packs Ordered cannot be negative',
									});
									return;
								}
								handleEditClick(getElementId(product));
							}}
						>
							<CheckCircle />
						</IconButton>
					</div>
				);
			}
			return (
				<span className={styles['order-qty']}>
					<p>{displayValue}</p>
					{!data?.nonEditable && (
						<IconButton
							onClick={() => {
								handleEditClick(getElementId(product));
							}}
							className={styles['edit-btn']}
						>
							<ModeEdit />
						</IconButton>
					)}
				</span>
			);
		},
		'Available Packs in Stock': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.availablePacks ?? product?.stock ?? '-';
		},
		'Packs to be packed': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.packsToBePacked ?? product?.finalProduction ?? '-';
		},
		'Qty of SKU required': (id) => {
			const product = listData?.PACKAGING?.find((prod) => {
				return getElementId(prod) === id;
			});
			return product?.qtyOfSkuRequired ?? product?.calculatedQty ?? '-';
		},
	};

	const getRowStyles = (ele) => {
		if (ele?.notScheduled === true) {
			return styles.notScheduledRow;
		}
		if (ele?.scheduledAtDelta > 0) {
			return styles.deltaHigh;
		}
		if (ele?.updatedQty !== null && ele?.updatedQty !== ele?.orderedQty) {
			return styles.updated;
		}
		if (ele?.skipped && selectedType?.value !== 'INGREDIENT') {
			return styles.skipped;
		}
		return '';
	};

	const handleSelectType = (e, value) => {
		if (value) {
			setSelectedType(value);
		}
	};

	const DATA = useMemo(() => {
		return (listData?.[selectedType?.value] ?? [])
			?.filter((ele) => {
				return (
					ele?.productName
						?.toLowerCase()
						?.indexOf(searchQuery?.toLowerCase()?.trim()) !== -1
				);
			})
			?.map((ele) => {
				const rowStyles = getRowStyles(ele);
				const isNotScheduled = ele?.notScheduled === true;
				return {
					...ele,
					id: getElementId(ele),
					rowStyles,
					styleCss: isNotScheduled ? {
						background: 'linear-gradient(to bottom, transparent 0%, transparent calc(50% - 0.5px), #000 calc(50% - 0.5px), #000 calc(50% + 0.5px), transparent calc(50% + 0.5px), transparent 100%)'
					} : undefined,
				};
			});
	}, [listData, selectedType, searchQuery]);

	const handleExport = () => {
		const headers = SPECIAL_COLUMNS?.map((ele) => {
			return ele?.title;
		})?.filter((ele) => {
			return ele !== 'Final Indent' && ele !== 'Recipe Exists';
		});
		headers?.splice(1, 0, ...['Variant Name', 'Sku Type']);
		const totalValues = [];
		const exportData = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
			...(listData?.INGREDIENT ?? []),
			...(listData?.UNPACKED_PRODUCT ?? []),
		];
		exportData?.forEach((product) => {
			const delta =
				product?.updatedQty !== product?.orderedQty
					? product?.updatedQty - product?.orderedQty
					: 0;
			let str = '';
			if (product?.scheduledAtDelta) {
				if (product?.scheduledAtDelta < 0) {
					str = 'T' + product?.scheduledAtDelta;
				} else if (product?.scheduledAtDelta === 0) {
					str = 'T';
				} else {
					str = 'T+' + product?.scheduledAtDelta;
				}
			}
			totalValues?.push([
				product?.productName ?? '-',
				product?.variantName ?? '-',
				product?.productType ?? '-',
				product?.unit ?? '-',
				product?.categoryName ?? '-',
				product?.fromProcess ?? '-',
				product?.toProcess ?? '-',
				str ?? '-',
				product?.stock ?? '-',
				product?.currentDayStockIn ?? '-',
				product?.currentDayCount ?? '-',
				product?.prePlanStock ?? '-',
				product?.threshold ?? '-',
				product?.orderedQty ?? '-',
				'-',
				delta ?? '-',
				product?.expectedLeftOver ?? '-',
				product?.calculatedQtyNonAdjusted ?? '-',
				(product?.leftOver ?? '') +
				'/' +
				(product?.inputLeftOver ?? '') ?? '-',
				product?.plannedLeftOver ?? '-',
				product?.leftOver ?? '-',
				(product?.calculatedQty +
					(product?.calculatedQtyNonAdjusted < 0
						? // eslint-disable-next-line prefer-template
						'(' + product?.calculatedQtyNonAdjusted + ')'
						: '')) ?? '-',
				product?.wastage ?? '-',
				product?.batchSize ?? '-',
				product?.finalProduction ?? '-',
			]);
		});
		handleExcelDownload(
			headers,
			totalValues,
			`Production Plan for ${moment(selectedDate).format('DD-MMM')}`
		);
	};
	const storeName = stores?.find(s => s.id === data?.storeId)?.name || '';

	return (
		<BaseModal
			heading={
				data?.editMode
					? `Edit Production Plan for ${moment(selectedDate).format('DD-MMM')} ${storeName ? `(${storeName})` : ''}`
					: `Production Plan for ${moment(selectedDate).format('DD-MMM')} ${storeName ? `(${storeName})` : ''}`
			}
			open={show}
			handleClose={handleClose}
			customStyles={{
				width: '95%',
				height: '95vh',
				...(data?.editMode && { background: 'rgb(255 254 248)' }),
			}}
			renderBtns={renderBtns}
			disableBackdropClick
			disableEscapeKeyDown
		>
			<AlertModal />
			<div className={`${styles.root}`}>
				<div className='w-full flex items-center justify-between'>
					<div className={styles.filters}>
						<Input
							className={styles.search}
							value={searchQuery}
							onChange={(e) => {
								setSearchQuery(e.target.value);
							}}
							placeholder='Search SKU'
						/>
						<ToggleButtonGroup
							value={selectedType}
							exclusive
							onChange={handleSelectType}
							style={{
								background: selectedType?.color,
								border: 'none',
							}}
						>
							{skuTypes?.map((ele) => {
								return (
									<ToggleButton
										style={{
											border: 'none',
											background: ele?.color,
										}}
										key={ele?.value}
										value={ele}
									>
										{ele?.value}
									</ToggleButton>
								);
							})}
						</ToggleButtonGroup>
						{/* Legend for Not Scheduled */}
						<div className='flex items-center gap-2 text-xs text-gray-600 border border-gray-200 rounded-md px-3 py-1.5 bg-gray-50'>
							<span className='relative px-2'>
								Row
								<span className='absolute left-0 right-0 top-1/2 h-px bg-black'></span>
							</span>
							<span className='text-gray-500'>= Not Scheduled</span>
						</div>
					</div>
					{/* {
						selectedType?.value === 'INGREDIENT' && (
							<div className='flex items-center space-x-2'>
								<div className='flex items-center '>
									<div className='flex gap-1 items-center px-1 py-1 rounded-full bg-gray-200'>
										<div className='w-3 h-3 rounded-full bg-gray-400' />
										<div className='text-xs text-nowrap'>Current Stock of WAREHOUSE</div>
									</div>
								</div>
								<div className='flex items-center '>
									<div className='flex gap-1 items-center px-3 py-1 rounded-full bg-blue-200'>
										<div className='w-3 h-3 rounded-full bg-blue-400' />
										<div className='text-xs text-nowrap'>Total Required</div>
									</div>
								</div>
								<div className='flex items-center'>
									<div className='flex gap-1 items-center px-3 py-1 rounded-full bg-red-200'>
										<ArrowDownward
											style={{
										color: '#EF4444',
										width: '16px',
										height: '16px',
										marginRight: '8px',
									}}
										/>
										<div className='text-xs text-nowrap'>Low Stock of WAREHOUSE</div>
									</div>
								</div>
							</div>
					)
					} */}
				</div>
				<div
					style={{
						background: selectedType?.color,
					}}
					className={classes(
						styles.list,
						data?.hideButtons ? styles.fullHeight : ''
					)}
				>
					<ListTable
						colMap={
							selectedType?.value === 'PACKAGING' ? {} : COLMAP
						}
						fixedHeaderTop={0}
						columns={[]}
						data={DATA}
						onExportClick={handleExport}
						actions={[...SPECIAL_COLUMNS]?.filter((ele) => {
							// When lppId is present, show only specific columns for PRODUCT and INTERMEDIATE
							if (data?.lppId && (selectedType?.value === 'PRODUCT' || selectedType?.value === 'INTERMEDIATE')) {
								const lppColumns = [
									'Product Name',
									'Unit',
									'Category',
									'Sub Category',
									'SKU Code',
									'Batch Size',
									'Pre Batch Production Quantity',
									'Recipe Exists',
									'No of batches',
									'Shift Name',
									'Parent Product',
									'Select Yield Process',
									'Kit Batch Size',
									'Kit Count',
									'Labelling Date',
									'Scheduled Date',
								];
								return lppColumns.includes(ele?.title);
							}
							let columnsToExclude = [
								'Final Indent',
								'Expected Left Over',
								'From Process',
								'To Process',
								'Pre Batch Without Left Over',
								'Left Over (Input)',
							];
							if (selectedType?.value === 'PRODUCT') {
								columnsToExclude?.push(
									...[
										'Wastage %',
										'Left Over (From Executed plans)',
										'Left Over (Used/Input)',
										'Left Over (Already Planned)',
										`Plan ${stockCheckAtDate} Planned Extra Production`,
										'Stock Info',
										'Required Stock',
										'Current Stock',
										'Measure Quantity',
										`Planned For Consumption ${plannedDate}`,
										`Planned To be Received ${plannedDate}`,
									]
								);
								if (data?.lppId) {
									columnsToExclude.push(
										'Parent Product',
										`Order Quantity PO Delivery Date ${scheduledFor}`,
										'Forecast for Next 7 Days',
										`Stock At ${stockCheckedAt}`,
										`Projected Stock at ${nextStockCheckAtDate} 7:59 AM`,
									);
								} else {
									columnsToExclude.push(
										'No of batches',
										'Shift ID',
										'Shift Name',
										'Parent Product',
										'Kit Batch Size',
										'Kit Count',
										'Labelling Date',
										'Scheduled Date'
									);
								}
								if (!(reasonList && reasonList.length > 0)) {
									columnsToExclude.push('Reason');
								}
							}
							if (selectedType?.value === 'INTERMEDIATE') {
								columnsToExclude?.push(
									...[
										'Stock At ' + stockCheckedAt,
										'Plan ' +
										stockCheckAtDate +
										' Produced till ' +
										stockCheckedAt,
										'Plan ' +
										stockCheckAtDate +
										' Planned Production',
										'Left Over (From Executed plans)',
										'Left Over (Used/Input)',
										'Left Over (Already Planned)',
										'Stock Info',
										'Required Stock',
										'Current Stock',
										'Measure Quantity',
										`Planned For Consumption ${plannedDate}`,
										`Planned To be Received on ${plannedDate}`,
									]
								);
								if (data?.lppId) {
									columnsToExclude.push(
										'Left Over (Input)',
										`Plan ${stockCheckAtDate} Planned Extra Production`,
										`Projected Stock at ${nextStockCheckAtDate} 7:59 AM`,
										`Minimum Stock at ${nextStockCheckAtDate} 7:59 AM`,
										`Order Quantity PO Delivery Date ${scheduledFor}`,
										'Forecast for Next 7 Days'
									);
								} else {
									columnsToExclude = columnsToExclude?.filter(
										(col) => {
											return col !== 'Left Over (Input)';
										}
									);
									columnsToExclude.push(
										'No of batches',
										'Shift ID',
										'Shift Name',
										'Parent Product',
										'Kit Batch Size',
										'Kit Count',
										'Labelling Date',
										'Scheduled Date'
									);
								}
								if (!(reasonList && reasonList.length > 0)) {
									columnsToExclude.push('Reason');
								}
							}
							if (selectedType?.value !== 'PRODUCT' && selectedType?.value !== 'INTERMEDIATE') {
								columnsToExclude.push('Reason');
							}
							if (selectedType?.value !== 'INGREDIENT') {
								columnsToExclude?.push('Scheduled');
							}
							if (selectedType?.value === 'PACKAGING') {
								columnsToExclude?.push(
									'No of batches',
									'Shift ID',
									'Shift Name',
									'Parent Product',
									'Select Yield Process',
								);
							}
							if (selectedType?.value === 'INGREDIENT') {
								columnsToExclude = [
									'Left Over (Input)',
									'Recipe Exists',
									'Final Production',
									'Production Factor (+/- Manual Calibration)',
									'Production Factor (+/- Manual Calibration)',
									// eslint-disable-next-line prefer-template
									'Possible Production Qty',
									'Stock At ' + stockCheckedAt,
									'Plan ' +
									stockCheckAtDate +
									' Produced till ' +
									stockCheckedAt,
									'Plan ' +
									stockCheckAtDate +
									' Planned Production',
									'Projected Stock at ' +
									nextStockCheckAtDate +
									' 7:59 AM',
									'Minimum Stock at ' +
									nextStockCheckAtDate +
									' 7:59 AM',
									'Order Quantity PO Delivery Date ' +
									scheduledFor,
									'Select Yield Process',
									`Plan ${stockCheckAtDate} Planned Extra Production`,
									// eslint-disable-next-line prefer-template
									...(!isLeftOverCheck
										? [
											'Left Over (From Executed plans)',
											'Left Over (Already Planned)',
										]
										: []),
									...(!isA2bCustomer ? ['Measure Quantity'] : []),
									'No of batches',
									'Shift ID',
									'Shift Name',
									'Parent Product',
									'Kit Batch Size',
									'Kit Count',
									'Labelling Date',
									'Scheduled Date',
								];

								if (data?.lppId) {
									columnsToExclude.push(
										'Scheduled',
										'Forecast for Next 7 Days',
										'Expected Left Over',
										'Required Stock',
										'Current Stock',
										'Status',
										'Pre Batch Without Left Over',
										'Left Over (Used/Input)',
										'Left Over (Already Planned)',
										'Left Over (From Executed plans)'
									);
								}
							}
							return !columnsToExclude?.includes(ele?.title);
						})}
						special={SPECIAL_ITEMS}
					/>
				</div>
				{/* Removed save draft button */}
				{/* <button
					onClick={() => handleSaveDraft()}
					className='px-4 py-2 bg-blue-600 text-white rounded absolute left-0 bottom-0 flex-1 w-[49%]'
				>
					{isDraftEdit ? 'Update Draft' : 'Save as Draft'}
				</button> */}
				<div className={`flex items-center gap-6 mt-4 ${!data?.hideButtons ? 'justify-between' : ''}`}>
					{/* Planning for Date */}
					<div className='flex items-center gap-3'>
						<label className='text-red-600 font-medium whitespace-nowrap text-sm'>
							Planning for Date
						</label>
						<DatePicker
							placeholder='dd/MM/yyyy'
							format='dd/MM/yyyy'
							className='w-[200px]'
							value={selectedDate}
							onChange={(date) => setSelectedDate(date)}
							menuStyle={{
								zIndex: 1000,
							}}
							placement='top'
							cleanable={false}
							disabled={data?.nonEditable}
							disabledDate={(date) => date < new Date().setHours(0, 0, 0, 0)}
						/>
					</div>

					{/* Select Shift */}
					<div className='flex items-center gap-3'>
						<label className='text-red-600 font-medium whitespace-nowrap text-sm'>
							Select Shift
						</label>
						<SelectPicker
							data={filteredShiftList?.map((ele) => ({
								label: ele?.shiftName,
								value: ele?.id,
							}))}
							placeholder='Select'
							className='w-[200px]'
							menuStyle={{
								zIndex: 10000,
							}}
							value={shiftId}
							onChange={(value) => setShiftId(value)}
							placement='top'
							cleanable={true}
							searchable={true}
							disabled
						/>
					</div>

					{/* Plan Name */}
					{!data?.hideButtons && (
						<div className='flex items-center gap-3 flex-1'>
							<label className='text-red-600 font-medium whitespace-nowrap text-sm'>
								Plan Name
							</label>
							<Input
								value={planDescription}
								onChange={handleChange}
								placeholder='Description'
								className='flex-1'
							/>
						</div>
					)}
				</div>
				{checkLowStock() && (
					<p className='text-xs font-medium text-red-500 p-1'>
						Certain items in this plan cannot be fullfilled
						completely due to low stock. Please check the plan and
						adjust the quantities accordingly to generate the
						production plan.
					</p>
				)}
				{(Object.keys(isEdit)?.length > 0 || Object.keys(isEditFinalProduction)?.length > 0) && (
					<p className='text-xs font-medium text-red-500 p-1'>
						The production manual factor has changed. Please save the changes (click the checkmark icon) and recalculate the plan to generate.
					</p>
				)}
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.productionPlanModal;
	const stores = state?.form?.STORES?.data?.LIST;
	return {
		show,
		data,
		stores,
	};
};

const mapDispatchToProps = {
	toggleProductionPlanModal: modalActions.toggleProductionPlanModal,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductionPlanModal);
